import React from 'react';

import classNames from 'classnames';

const BLANK_PLACEHOLDER = '—';

// RAG letter → dot colour (A = Amber, R = Red, G = Green), mirroring
// GeneralRisk::CLASSIFICATION_COLORS.
const ragColourClass = (rag) =>
    classNames('tw-inline-block tw-w-2.5 tw-h-2.5 tw-rounded-full', {
        '!tw-bg-red-500': rag === 'R',
        '!tw-bg-yellow-400': rag === 'A',
        '!tw-bg-green-500': rag === 'G',
        'tw-bg-charcoal-25': rag !== 'R' && rag !== 'A' && rag !== 'G',
    });

/**
 * A single detailed RADIO item row.
 *
 * Reads the normalised row keys emitted by the RADIO sources:
 *   { type, description, status_label, rag_classification, priority, owner,
 *     impact_category, afc_label, actions_summary }
 *
 * `columns` is the resolved set of visible value columns for this render.
 */
const RadioReportTableRow = ({ row, columns }) => (
    <tr className="tw-text-xs !tw-bg-white">
        <td className="!tw-bg-charcoal-15 tw-text-charcoal tw-whitespace-nowrap tw-font-medium">{row.type || BLANK_PLACEHOLDER}</td>

        <td className="!tw-bg-charcoal-15 tw-text-charcoal">{row.description || BLANK_PLACEHOLDER}</td>

        {columns.status && <td>{row.status_label || BLANK_PLACEHOLDER}</td>}

        {columns.rag && (
            <td>{row.rag_classification ? <span className={ragColourClass(row.rag_classification)} title={row.rag_classification} /> : BLANK_PLACEHOLDER}</td>
        )}

        {columns.priority && <td className="tw-capitalize">{row.priority || BLANK_PLACEHOLDER}</td>}

        {columns.owner && <td>{row.owner || BLANK_PLACEHOLDER}</td>}

        {columns.impact_category && <td>{row.impact_category || BLANK_PLACEHOLDER}</td>}

        {columns.afc && <td>{row.afc_label || BLANK_PLACEHOLDER}</td>}

        {columns.actions && <td>{row.actions_summary || BLANK_PLACEHOLDER}</td>}
    </tr>
);

export default RadioReportTableRow;
